import { useQuery } from '@tanstack/react-query';

import { API } from '@/shared/api';

import { NOTIFICATIONS_POLLING_INTERVAL, RQ_NOTIFICATIONS_KEY } from '../lib/constants';

export const useGetNotifications = (enabled: boolean) => {
  return useQuery({
    enabled,
    queryFn: API.getNotifications,
    queryKey: RQ_NOTIFICATIONS_KEY,
    refetchInterval: NOTIFICATIONS_POLLING_INTERVAL,
  });
};
